<template>
  <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Categoria:"
    id="selectAssunto"
    placeholder="Selecione a(s) Categoria(s)"
    :multiple="multiple"
    :getOptionLabel="option => option.text"
    @update:value="handleValueUpdate"
  />
</template>

<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import CategoriaRepository from '@/shared/http/repositories/nxSenhas/categoria.js'

export default {
  name: 'NxSelectNxSenhasCategoria',
  mixins: [useReactiveModelMixin('value')],
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadCategoria()
  },
  methods: {
    onLoadCategoria () {
      CategoriaRepository.GetAllPaging()
        .then((response) => {
          this.listOptions = response.data.content.map((x) => ({
            value: x.id,
            text: x.nome || 'Sem nome'
          }))
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Categorias', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
      this.$emit('update:value', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectNxSenhasCategoria.vue